import { type AppConfiguration } from '#app/types.js';
import { AppConfigurationContext } from './AppConfigurationContext.js';
import { type ReactNode } from 'react';

export const AppConfigurationProvider = ({
  appConfiguration,
  children,
}: {
  readonly appConfiguration: AppConfiguration;
  readonly children: ReactNode;
}) => {
  return (
    <AppConfigurationContext.Provider value={appConfiguration}>
      {children}
    </AppConfigurationContext.Provider>
  );
};
